import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export const buildCommonHeaders = (token: string): any => {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };  
}

export default axiosInstance;
